<template>
    <b-container class="p-0">

        <b-row class="m-0">      
            
            <b-col>

                <b-row class="m-0 center filter-by-tags-label"> Выберите группу тегов </b-row>

                <b-row class="m-0 center">

                    <div v-for="(item, index) in options"
                        :key="index"
                        class="container-tag"
                        :style="setStyleTag(item)"
                        @click="selectParentTag(item)">

                        {{item.Name}}
                    </div>

                </b-row>

            </b-col>

        </b-row>

        <hr v-if="parentTag" class="my-4" />

        <b-row class="m-0" v-if="parentTag">

            <b-col class="p-0">

                <b-row class="m-0 center filter-by-tags-label"> Выберите тег </b-row>
                
                <b-row class="m-0 center">

                    <div  v-for="(item, index) in parentTag.SubTags"
                            :key="index"
                            class="container-tag"
                            :style="setStyleSubTag(item)"
                            @click="selectTag(item)">
                        {{item.Name}}
                    </div>

                </b-row>

            </b-col>

        </b-row>

    </b-container>
    
</template>

<script>
export default {
    model: {
        prop: 'value',
        event: 'select'
    },
    props: {
        value: [Object, Array],
        options: Array
    },
    data: function() {
       return {
            parentTag: null
        }
    },
    methods: {
        selectParentTag: function(item) {
            if(this.parentTag == item) {}
                //this.parentTag = null;
            else {
                this.parentTag = item;
                this.$emit('select', null);
            }
        },
        selectTag: function(item) {
            if(item == this.value) {
                //this.$emit('select', null);
            }                
            else
                this.$emit('select', item)
        },
        setStyleTag: function(item) {
            return this.parentTag == item
                        ? "color: white; background-color: #86be44; border-color: #86be44"
                        : "color: #86be44"
        },
        setStyleSubTag: function(item) {
            if(item.Color)
                return this.value == item
                            ? `color: white; background-color: ${item.Color}; border-color: ${item.Color}`
                            : `color: ${item.Color}`;
            else
                return this.value == item
                        ? "color: white; background-color: #86be44; border-color: #86be44"
                        : "color: #86be44"
        }
    }
}
</script>

<style>
.container-tag {
    width: auto; 
    margin:7px; 
    padding: 5px 10px; 
    border: 1.2px solid; 
    border-radius: 16px; 
    cursor: pointer
}

.container-tag:hover {
    box-shadow: 0px 1px 8px rgb(199, 199, 199); 
}

.filter-by-tags-label {
    font-size: 12px;
    line-height: 22px;
    letter-spacing: 1px;
    color: #949494;
    font-weight: normal;
}
</style>